// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MessageBox_wrapper__16JQ6","title":"MessageBox_title__1jbit","body":"MessageBox_body__X5Olh","actions":"MessageBox_actions__3Uz8O"};